// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n\n/*font: 300 18px Montserrat;*/\n.cli-loader__slash {\n\t\tdisplay: inline-block;\n\t\tmin-width: 1em;\n}\n.cli-loader.fetch--pending {\n\t    margin-bottom: var(--page-pad);\n}\nbutton .cli-loader {\n\tdisplay: inline-block;\n}\n\n/*.l-main > .fetch > .cli-loader {\n  position: absolute;\n  right: 66px;\n  right: 0;\n  top: -31px;\n}*/\n\n", ""]);
// Exports
module.exports = exports;
